import { Grid, Typography } from '@mui/material';

import { SelectionList } from '../../components';
import { CHILD_BACKGROUND_CONFIGS } from '../constants';
import { CHILD_BACKGROUND_ADD_BUTTON_SX, CHILD_SECTION_LABEL_SX } from '../styles';
import { getChildBackgroundEntries } from '../utils';

import type { ChildBackgroundListsProps } from './types';

export default function ChildBackgroundLists({
  backgrounds,
  disabled,
  showListErrors,
  behaviorIssuesField,
  onAdd,
  onDelete,
}: ChildBackgroundListsProps) {
  return (
    <Grid container spacing={2}>
      {CHILD_BACKGROUND_CONFIGS.map((config) => {
        const entries = getChildBackgroundEntries(backgrounds, config.type);
        return (
          <Grid item xs={12} md={6} key={config.type}>
            <Typography variant="body1" sx={CHILD_SECTION_LABEL_SX}>
              {config.label}
            </Typography>
            <SelectionList
              addButtonLabel={config.addButtonLabel}
              addButtonSx={CHILD_BACKGROUND_ADD_BUTTON_SX}
              disabled={disabled}
              entries={entries}
              error={showListErrors && entries.length < (config.minItems ?? 1)}
              freeText={config.freeText}
              getDeleteConfirm={(entry) => ({
                title: `Confirm ${config.label.toLowerCase()} deletion?`,
                message: `You are about to delete "${entry.value}"`,
              })}
              label={config.label}
              onAdd={(value) => onAdd(config.type, value)}
              onDelete={onDelete}
              options={config.options}
              placeholder={config.placeholder}
              required
            />
          </Grid>
        );
      })}
      <Grid item xs={12} md={6}>
        <Typography variant="body1" sx={CHILD_SECTION_LABEL_SX}>
          Other child behavior issues
        </Typography>
        {behaviorIssuesField}
      </Grid>
    </Grid>
  );
}
